import React from 'react'
import sv from '../../styles/marketing'
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {StretchedBackground} from "../commons/StretchedBackground";

// STYLE ##########################################################

const Content = styled(`div`)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  bottom: 0;
  align-items: center;
  width: 100%;
  padding: 90px 10px 50px 10px;
`;

const Title = styled(`div`)`
  ${sv.title};
  color: ${sv.colors.headline};
  margin-bottom: 16px;
`;

const Info = styled(`div`)`
  line-height: 1.3em;
  font-size: 18px;
  color: ${sv.colors.dark};
  margin-bottom: 20px;
`;

const PitchButton = styled(`div`)`
  font-size: 15px;
  ${sv.buttonBase};
  background: ${props => props.brightColor ? 'rgba(255,255,255,.75)' : sv.colors.cta};
  color: ${props => props.brightColor ? sv.colors.body : sv.colors.light};
  box-shadow: 0 2px 4px rgba(0,0,0,.05);
  border: ${props => props.brightColor ? ('2px ' + sv.colors.subtleGrey + ' solid') : ''};
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
  }
`;

// COMPONENT ##########################################################

export function GetStartedPitch() {
	
	const {t} = useTranslation();
	const history = useHistory();
	
	const onClickGetStarted = () => {
		// redirect to signup
		history.push("/signup");
	}
	
	return(
			<StretchedBackground backgroundColor={sv.colors.cream}>
				{/* content */}
				<Content>
					<Title>{t("Try Gistify for free.")}</Title>
					<Info>{t("30 day free trial, no credit card needed.")}</Info>
					<PitchButton onClick={()=>onClickGetStarted()}>{t("Get Started")}</PitchButton>
				</Content>
			</StretchedBackground>
	);
}